(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fb-header"] && !Shopify.designMode) return;
  try {
    
  const fbHeaders = document.querySelectorAll('[data-fb-header]');
  fbHeaders.forEach((header) => {
    const toggle = header.querySelector('[data-fb-mobile-toggle]');
    const panel = toggle ? document.getElementById(toggle.getAttribute('aria-controls')) : null;
    if (toggle && panel) {
      toggle.addEventListener('click', () => {
        const open = panel.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', String(open));
      });
    }
    const menus = header.querySelectorAll('[data-fb-menu]');
    menus.forEach((menu) => {
      menu.addEventListener('mouseenter', () => {
        menus.forEach((item) => { if (item !== menu) item.open = false; });
        menu.open = true;
      });
      menu.addEventListener('mouseleave', () => { menu.open = false; });
      menu.addEventListener('toggle', () => {
        if (menu.open) menus.forEach((item) => { if (item !== menu) item.open = false; });
      });
    });
    header.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        menus.forEach((menu) => { menu.open = false; });
        if (panel) panel.classList.remove('is-open');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      }
    });
    document.addEventListener('click', (event) => {
      if (!header.contains(event.target)) menus.forEach((menu) => { menu.open = false; });
    });
  });
  const fbSliderWraps = document.querySelectorAll('[data-fb-slider-wrap]');
  fbSliderWraps.forEach((wrap) => {
    const slider = wrap.querySelector('[data-fb-slider]');
    if (!slider) return;
    wrap.querySelectorAll('[data-fb-direction]').forEach((button) => {
      button.addEventListener('click', () => {
        const direction = button.dataset.fbDirection === 'next' ? 1 : -1;
        slider.scrollBy({left: slider.clientWidth * 0.82 * direction, behavior: 'smooth'});
      });
    });
  });
  const fbWishlistButtons = document.querySelectorAll('[data-fb-wishlist]');
  const fbWishlistCounts = document.querySelectorAll('[data-fb-wishlist-count]');
  const fbWishlistKeys = () => Object.keys(localStorage).filter((key) => key.startsWith('fb-wishlist-') && localStorage.getItem(key));
  const fbUpdateWishlist = () => {
    const count = fbWishlistKeys().length;
    fbWishlistCounts.forEach((badge) => {
      badge.textContent = count > 99 ? '99+' : String(count);
      badge.hidden = count === 0;
    });
    fbWishlistButtons.forEach((button) => {
      const active = Boolean(localStorage.getItem(`fb-wishlist-${button.dataset.fbWishlist}`));
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });
  };
  fbWishlistButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const key = `fb-wishlist-${button.dataset.fbWishlist}`;
      if (localStorage.getItem(key)) localStorage.removeItem(key);
      else localStorage.setItem(key, '1');
      fbUpdateWishlist();
      window.dispatchEvent(new CustomEvent('fb:wishlist:change'));
    });
  });
  window.addEventListener('storage', (event) => { if (!event.key || event.key.startsWith('fb-wishlist-')) fbUpdateWishlist(); });
  window.addEventListener('fb:wishlist:change', fbUpdateWishlist);
  fbUpdateWishlist();

  } catch(e) { console.error(e); }
})();
})();
